import { useCallback } from "react";
import { useAuth } from "@workos-inc/authkit-react";
import { apiFetch } from "@/lib/api";

export function useAuthenticatedFetch() {
  const { getAccessToken } = useAuth();

  return useCallback(
    <T>(path: string, init?: RequestInit) =>
      apiFetch<T>(path, getAccessToken, init),
    [getAccessToken],
  );
}
